import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';
import { get } from 'lodash';
import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import { getDataLayer } from 'common/utilities/utils';

/**
 *
 * @param {*} data - footer module data - Object
 */
export const modifyData = footerData => {
  const { FOOTER_LOGO, FOOTER_SECTION, FIND_A_KFC_SECTION, APP_LINKS, SOCIAL_SECTION, COPYRIGHT } = FOOTER_CONSTANT;

  const bodyContent = {
    kfcLogo: {},
    categories: [],
    kfcStoreSearch: {},
    downloadAppButtons: [],
  };
  const footerContent = {
    languageDropdown: {},
    copyrightContentData: {},
    socialMediaContent: [],
  };

  for (const footerItem of footerData) {
    const contentType = get(footerItem, 'sys.contentType.sys.id');
    const category = get(footerItem, 'fields.category');
    if (contentType === FOOTER_LOGO) {
      const { url: src, altText: alt } = modifyImageItemData(footerItem.fields);
      bodyContent.kfcLogo = { src, alt };
    } else if (category === FIND_A_KFC_SECTION) {
      let spittedTitle = footerItem.fields.links[0].fields.linkText.split(' ');
      let modifiedTitle = spittedTitle[0] + ' ' + spittedTitle[1].toLowerCase() + ' ' + spittedTitle[2];
      bodyContent.kfcStoreSearch = {
        ...modifyChildrenData(footerItem.fields.links[0].fields),
        name: modifiedTitle,
      };
    } else if (category === APP_LINKS) {
      bodyContent.downloadAppButtons = modifyAppData(footerItem.fields.links);
    } else if (category === SOCIAL_SECTION) {
      footerContent.socialMediaContent = modifySocialData(footerItem.fields.links);
    } else if (category === COPYRIGHT) {
      const { headline: name } = footerItem?.fields?.links[0]?.fields || {};
      footerContent.copyrightContentData = { name };
    } else if (contentType === FOOTER_SECTION) {
      bodyContent.categories.push(modifyCategoryData(footerItem.fields));
    } else {
      /* DO NOTHING : THIS IS TO AVOID SONAR RULES */
    }
  }
  return { bodyContent, footerContent };
};

const modifyAppData = items => {
  return(
    items.map(item => {
      return { ...getAppImageData(item.fields), name: item.fields.title };
    }) || []
  )
};

const getAppImageData = item => {
  const { url: linkTo, desktopImage: icon = {} } = item;
  const { file: desktopImage = {} } = icon.fields;
  const { url = '' } = desktopImage;
  return { linkTo, url };
};

/**
 * method to modify footer social data structure
 * @param {*} items item
 */
const modifySocialData = items => {
  return(
    items.map(item => {
      const { externalurl: linkTo, icon = {} } = item.fields;
      const { url } = modifyImageItemData(icon.fields);
      const childrenData = { linkTo, url };
      return { ...childrenData, name: item.fields.title };
    }) || []
  )
};

/**
 * method to modify icon item data structure
 * @param {*} item nav item
 */
const modifyImageItemData = item => {
  const { desktopImage } = item;
  return (desktopImage && getImage(desktopImage)) || {};
};

/**
 * method to get item image url
 * @param {*} desktopImage
 */
const getImage = desktopImage => {
  const { url = '', altText = '' } = (desktopImage.fields && desktopImage.fields.file) || {};
  return { url, altText };
};

/**
 * method to modify category data
 * @param {*} item
 */
const modifyCategoryData = item => {
  let subCategories = [];
  const { category: categoryHeaderText, links = [] } = item;
  links.forEach(linkitem => {
    subCategories.push(modifySubcategoryData(linkitem.fields));
  });
  return { categoryHeaderText, subCategories: subCategories };
};

/**
 * method to modify subcategory data
 * @param {*} item
 */
const modifySubcategoryData = item => {
  const { linkText: name, internalurl, externalurl } = item;
  const linkTo = item.url || item.internalurl;
  return { name, linkTo, internalurl, externalurl };
};

/**
 * method to modify children data
 * @param {*} item
 */
const modifyChildrenData = item => {
  const { externalurl: linkTo, icon = {} } = item;
  const { url } = modifyImageItemData(icon.fields);
  return { linkTo, url };
};

/**
 * method to modify language data based on tenantReducer allowed languages
 */
export const getAllowedLanguage = (languages, basic) => {
  let languageObject = languages;
  languageObject.options = [];
  const { allowedLanguages } = basic || { allowedLanguages: [{ value: '' }] };
  if (allowedLanguages.length) {
    for (let lang of allowedLanguages) {
      languageObject.options.push(lang.value);
    }
    return languageObject;
  }
  return {};
};

/**
 * Method to set analytics items in the data layer object
 */
export const setAnalyticsData = async analyticsData => {
  const analyticsItems = [];
  analyticsItems.push({
    event: 'footerLinks',
    navigationLink: analyticsData.footerItemSelected,
  });
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};
